export const ModernStores = [
    { label: 'Cadena Nacional', value: 'nacional' },
    { label: 'Cadena Regional', value: 'regional' },
    { label: 'Independiente', value: 'independiente' },
];

export const TraditionalStores = [
    { label: 'SMI', value: 'smi' },
    { label: 'Abasto', value: 'abastos' },
    { label: 'Farmacia', value: 'farmacia' },
    { label: 'Mayorista', value: 'mayorista' },
    { label: 'Panaderia', value: 'panaderia' },
    { label: 'Kiosko', value: 'kiosko' },
    { label: 'Bodega', value: 'bodega' },
    { label: 'Bodegon', value: 'bodegon' },
    { label: 'Horeca', value: 'horeca' },
    { label: 'Licoreria', value: 'licoreria' },
    { label: 'Confiteria', value: 'confiteria' },
    { label: 'Otro', value: 'otro' },
];
